<ng-container [ngSwitch]="hasNumber">
    <ng-container *ngSwitchCase="true">
        {{code}} {{number | spacer:spacing}}
    </ng-container>
    <ng-container *ngSwitchCase="false">
        -
    </ng-container>
</ng-container>

